import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { SalesPage } from "./components/SalesPage";
export function App() {
  return <>
      <MetaPixel data-id="element-0" data-mp="35eemmx2prmbg" />
      <SalesPage data-id="element-1" data-mp="3k9kttndjpr6d" />
    </>;
}